<template>
  <div class="flex-container">
      <div class="forgot-whitebox">
        <h1>Resend Verification Link</h1>
        <p class="desc">
          Enter your email address and we will send you a new verification link.
        </p>
        <div class="forgot-container">
          <div class="forgot-input">
            <input
              class="forgot-input-box required form-control"
              type="email"
              placeholder="E-mail address"
              v-model="email"
            />
            <i class="fa fa-envelope"></i>
          </div>
        </div>
        <div class="error-msg-holder" v-if="errorMessage">
          <span class="error-message" v-html="errorMessage"></span>
          <br />
        </div>
        <button
          class="btn mt-20 emergo-green-button"
          type="button"
          @click="postEmail"
          :disabled="disableButton || disableBtn"
        >
                  {{ btnTxt }}
        </button>
        <p class="desc mt-20">
          Please contact RAMS Support at <a href = "mailto:ramshelp@ul.com">ramshelp@ul.com</a> in case you have not received the new verification link.
        </p>
      </div>
      <verification-popup></verification-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import { postVerificationLink } from '../../apis/login';
import { isValidMail } from '../Register/validator';
import verificationPopup from './VerificationPopup.vue';

export default {
  data() {
    return {
      email: '',
      errorMessage: '',
      disableBtn: false,
      btnTxt: 'E-mail me a new link',
    };
  },
  components: {
    verificationPopup,
  },
  methods: {
    async postEmail() {
      this.errorMessage = '';
      this.btnTxt = 'Submitting Form...';
      this.disableBtn = true;
      const result = await postVerificationLink({ email: this.email });
      if (result && result.status) {
        $('#successMsgModal').modal('show');
      } else if (result && !result.status) {
        this.errorMessage = result.message;
      }
      this.disableBtn = false;
      this.btnTxt = 'E-mail me a new link';
    },
  },
  computed: {
    disableButton() {
      if (isValidMail(this.email)) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.flex-container {
  margin-top: 30px;
  text-align: center;
}
.forgot-whitebox {
  padding:0 10px;
  max-width: 450px;
  min-width: 450px;
}
.forgot-container {
  font-size: 16px;
  position: relative;
  padding-bottom: 10px;
}
.forgot-whitebox > h1 {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 48px;
  margin-bottom: 16px;
  line-height: 1;
}
.forgot-input-box {
  padding: 25px 35px 25px 50px;
}
.desc {
  margin-bottom: 20px;
  font-size: 15px;
  color: black;
}
.btn{
  padding: 7px 30px;
}
.mt-20 {
  margin-top: 20px;
}
.forgot-container .forgot-input > i.fa {
    position: absolute;
    top: 18px;
    left: 20px;
}
.mt-15 {
  margin-top: 15px;
}
@media screen and (max-width: 640px) {
  .forgot-whitebox {
    min-width: 95vw !important;
  }
}
@media screen and (max-width: 1024px) {
  .flex-container {
    margin: 15px !important;
  }
}
@media (min-width:320px) and (max-width:374px){
  .forgot-whitebox > h1 {
  font-size: 42px;
  }
  .desc{
    font-size: 13px;
  }
}
</style>
